import { MutationOptions, useMutation } from "react-query";
import { APIError, APIResponse, API_URL, post } from "../api";

/**
 * POST …/onboarding/users/onboarding/account/complete-profile → Laravel proxy → Core.
 * Uses Core JWT in localStorage `token` (from verify-email-otp), not Laravel Passport.
 */
function useCompleteOnboardingProfile(
  options?: MutationOptions<APIResponse<unknown>, APIError, { password: string }>
) {
  const {
    isLoading: completingProfile,
    isError: isCompleteProfileError,
    error: completeProfileError,
    mutate: completeProfile,
    reset,
  } = useMutation<APIResponse<unknown>, APIError, { password: string }>(
    "complete_onboarding_profile",
    async (variables) => {
      const token = localStorage.getItem("token");
      return await post(
        `${API_URL}/onboarding/users/onboarding/account/complete-profile`,
        variables,
        {
          headers: {
            "Content-Type": "application/json",
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
          },
        }
      );
    },
    options
  );

  return {
    completeProfile,
    completingProfile,
    isCompleteProfileError,
    completeProfileError,
    resetCompleteProfile: reset,
  };
}

export default useCompleteOnboardingProfile;
